import '@tyro/i18n';
import { initSentry } from '@tyro/router/sentry';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

if (process.env.NODE_ENV === 'development') {
  void import('react-grab');
}
import { AppShell } from './app';

export { useAppShellConfig } from './components/shell/provider';
export * from './assets/illustration_404';
export * from './router';
export * from './components/shell/nav/config';

initSentry(
  'https://6f0dc905b3566329a24bf2f3ab3efc64@o4505675714658304.ingest.sentry.io/4505680217964544',
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <AppShell />
  </StrictMode>,
);
